import { Injectable } from "@angular/core";
import { ITradeDealActionService, CHANNEL_TRADE_ACTION } from "../ITradeDealActionService";
import { TradeDealPromiseActionService } from "./TradeDealPromiseActionService";
import { CubiqWorker } from "../../worker/CubiqWorker";
import { BFXNotificationType } from "../../model/core/notifications/BFXNotificationType";
import { BFXNotificationSubType } from "../../model/core/notifications/BFXNotificationSubType";
import {
  PRIMITIVE,
  ServiceMessageBrokerFactory,
  ServiceMessageBroker,
} from "shared/provider-webworker";
import { Subject } from "rxjs";
import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { NotificationService } from "../../lookup/notification/impl/NotificationService";

import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Injectable()
export class TradeDealPrimaryActionService
  extends TradeDealPromiseActionService
  implements ITradeDealActionService
{
  protected broker: ServiceMessageBroker;

  constructor(
    private worker: CubiqWorker,
    protected factory: ServiceMessageBrokerFactory,
    private notifService: NotificationService,
  ) {
    super();
    this.broker = this.factory.createMessageBroker(CHANNEL_TRADE_ACTION, true, true);

    this.broker.registerMethod(
      "confirmTrade",
      [PRIMITIVE, PRIMITIVE],
      this.confirmTrade.bind(this),
      PRIMITIVE,
    );
    this.broker.registerMethod(
      "confirmTrades",
      [PRIMITIVE, PRIMITIVE],
      this.confirmTrades.bind(this),
      PRIMITIVE,
    );
    this.broker.registerMethod(
      "cancelTrade",
      [PRIMITIVE, PRIMITIVE],
      this.cancelTrade.bind(this),
      PRIMITIVE,
    );
    this.broker.registerMethod(
      "cancelTrades",
      [PRIMITIVE, PRIMITIVE],
      this.cancelTrade.bind(this),
      PRIMITIVE,
    );
    this.broker.registerMethod(
      "addFillComment",
      [PRIMITIVE, PRIMITIVE, PRIMITIVE],
      this.addFillComment.bind(this),
      PRIMITIVE,
    );
    this.broker.registerMethod(
      "initModelUpdateService",
      [PRIMITIVE],
      this.initModelUpdateService.bind(this),
      null,
      false,
    );
  }

  confirmTrade(dealId: string, action: CubiqTS.TradeActionType): Promise<any> {
    let request: CubiqTS.TradeActionRequestImpl = new CubiqTS.TradeActionRequestImpl();

    request.dealIds = new Array(dealId);
    request.tradeAction = action;

    return new Promise<any>((resolve, reject) => {
      this.worker.postServiceRequest(request).then((response) => {
        this.notifService.handleErrors(
          response,
          BFXNotificationType.TRADE_ACTION_FAIL,
          BFXNotificationSubType.TRADE_CONFIRM_FAIL,
        );
        resolve(response);
      });
    });
  }

  confirmTrades(dealIds: Array<string>, action: CubiqTS.TradeActionType): Promise<any> {
    let request: CubiqTS.TradeActionRequestImpl = new CubiqTS.TradeActionRequestImpl();

    request.dealIds = dealIds;
    request.tradeAction = action;

    return new Promise<any>((resolve, reject) => {
      this.worker.postServiceRequest(request).then((response) => {
        this.notifService.handleErrors(
          response,
          BFXNotificationType.TRADE_ACTION_FAIL,
          BFXNotificationSubType.TRADE_CONFIRM_FAIL,
        );
        resolve(response);
      });
    });
  }

  cancelTrade(dealId: string, action: CubiqTS.TradeActionType): Promise<any> {
    let request: CubiqTS.TradeActionRequestImpl = new CubiqTS.TradeActionRequestImpl();

    request.dealIds = new Array(dealId);
    request.tradeAction = action;

    return new Promise<any>((resolve, reject) => {
      this.worker.postServiceRequest(request).then((response) => {
        this.notifService.handleErrors(
          response,
          BFXNotificationType.TRADE_ACTION_FAIL,
          BFXNotificationSubType.TRADE_CANCEL_FAIL,
        );
        resolve(response);
      });
    });
  }

  cancelTrades(dealIds: Array<string>, action: CubiqTS.TradeActionType): Promise<any> {
    let request: CubiqTS.TradeActionRequestImpl = new CubiqTS.TradeActionRequestImpl();

    request.dealIds = dealIds;
    request.tradeAction = action;

    return new Promise<any>((resolve, reject) => {
      this.worker.postServiceRequest(request).then((response) => {
        this.notifService.handleErrors(
          response,
          BFXNotificationType.TRADE_ACTION_FAIL,
          BFXNotificationSubType.TRADE_CANCEL_FAIL,
        );
        resolve(response);
      });
    });
  }

  addFillComment(dealId: string, action: CubiqTS.TradeActionType, comment: string): Promise<any> {
    let request: CubiqTS.TradeActionRequestImpl = new CubiqTS.TradeActionRequestImpl();

    request.dealIds = new Array(dealId);
    request.tradeAction = action;
    request.comment = comment;

    return this.worker.postServiceRequest(request);
  }

  getModelNotificationFailureEventSubject(): Subject<CubiqTS.ConcreteEncodable> {
    return this.modelNotificationFailureEventSubject;
  }
}
